// extracted by mini-css-extract-plugin
export default {"collections_section":"CollectionsPage_collections_section__gly0Z"};